<mono-common-back-to-navigation-bar
  data-test="lmw-base-help-back-to-home-bar"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__top"
></mono-common-back-to-navigation-bar>
<main
  id="content"
  #content
  aria-describedby="ariaMainHeaderId"
  class="site-container site-container--help"
>
<div class="grid-container">
  <div class="grid-x grid-margin-x">
    <div class="cell">
      <h1 id="ariaMainHeaderId">
        {{ helpCms.data.attributes.title }}
      </h1>
      <p class="lead" *ngIf="!userSignedIn" [innerHTML]="helpCms.data.attributes.registerNag | dontSanitizeHtml"></p>
      <p class="lead">{{ helpCms.data.attributes.description }}</p>

      <mono-common-callout
        *ngIf="isMobile"
        data-test="lmw-help-callout--info"
        base="info"
        type="info-text"
        animation="no-animation"
        [calloutText]="helpCms.data.attributes.accordionHelpCallout.text"
        [ariaLabel]="helpCms.data.attributes.accordionHelpCallout.ariaLabel"
      >
      </mono-common-callout>
      <ng-container *ngIf="!isMobile">
        <section role="contentinfo" *ngFor="let section of helpCms.data.attributes.helpDesktop; let firstSection=first; let lastSection = last;">
          <div class="flex-container align-justify align-top">
            <h2 class="show-for-medium">{{ section.title }}</h2>
            <a
              *ngIf="!firstSection"
              [href]="helpLink + '#content'"
              class="button clear underline button--icon-on-left show-for-medium"
            >
              <svg class="icon icon--arrow-up icon--secondary">
                <use xlink:href="#icon-arrow-up" href="#icon-arrow-up"></use>
              </svg>
              <span class="normal-text">{{ helpCms.data.attributes.backToTopLink }}</span>
           </a>
          </div>
          <div class="content">
            <ng-container *ngFor="let instruction of section.helpInstructions; let firstInstruction = first;">
              <hr *ngIf="!firstInstruction && instruction.title" class="section--divider">
              <h3 *ngIf="instruction.title">{{ instruction.title }}</h3>
              <div [innerHTML]="instruction.description  | dontSanitizeHtml"></div>
              <img [src]="instruction.image?.data?.attributes?.url" alt="" />
            </ng-container>
          </div>
          <hr *ngIf="!lastSection" class="section" />
        </section>
      </ng-container>
      <ng-container *ngIf="isMobile">
        <section class="accordion" role="contentinfo" *ngFor="let section of helpCms.data.attributes.helpMobile; let index = index;">
          <button
            #accordionButton
            type="button"
            class="button button--accordion hide-for-medium"
            [ngClass]="'margin-bottom-0'"
            (click)="clickAccordionButton(accordionButton)"
            [attr.aria-controls]="'ariaControls' + index"
            id="{{'ariaLabelledBy' + index}}"
          >
            <h2 class="margin-0">{{ section.title }}</h2>
            <svg
              aria-hidden="true"
              class="icon icon--chevron-down icon--primary icon--material"
            >
              <use
                xlink:href="#icon-chevron-down"
                href="#icon-chevron-down"
              ></use>
            </svg>
          </button>
          <div class="content accordion__content" role="region" aria-live="polite" id="{{'ariaControls' + index}}" aria-labelledby="{{'ariaLabelledBy' + index}}">
            <h2 class="show-for-medium">{{ section.title }}</h2>
            <ng-container *ngFor="let instruction of section.helpInstructions; let firstInstruction = first;">
              <hr *ngIf="!firstInstruction && instruction.title" class="section--divider">
              <h3 *ngIf="instruction.title">{{ instruction.title }}</h3>
              <div [innerHTML]="instruction.description  | dontSanitizeHtml"></div>
              <img
                [src]="instruction.image?.data?.attributes?.url"
                alt=""
                class="margin-bottom-1-5"
              />
            </ng-container>
          </div>
        </section>
      </ng-container>
      <lmw-common-secondary-page-cta-panel
        data-test="lmw-common-help-secondary-cta-panel"
        [headingText]="helpCms.data.attributes.helpSecondSection.title"
        [paragraphText1]="helpCms.data.attributes.helpSecondSection.descriptionFirst"
        [paragraphText2]="helpCms.data.attributes.helpSecondSection.descriptionSecond"
        [firstLink]="browseAllSubjectsLink"
        [firstLinkText]="helpCms.data.attributes.helpSecondSection.browseSubjectsButton"
        [secondLink]="reportAnIssueLink"
        [secondLinkText]="helpCms.data.attributes.helpSecondSection.localSupportButton"
      >
      </lmw-common-secondary-page-cta-panel>
    </div>
  </div>
</div>
</main>
<mono-common-back-to-navigation-bar
  data-test="lmw-base-help-back-to-home-bar"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__bottom"
></mono-common-back-to-navigation-bar>
